export function anyToastExist(state){
    return state.toast.length != 0;
}